import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=f87852e2&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=f87852e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87852e2",
  null
  
)

export default component.exports